module.exports = __webpack_public_path__ + "static/media/josemiguel-250x251.143b1998.png";